import Vuex from '../dist/vuex.common.js'

const {
  Store,
  install,
  version,
  mapState,
  mapMutations,
  mapGetters,
  mapActions,
  createNamespacedHelpers,
  createLogger
} = Vuex

export {
  Vuex as default,
  Store,
  install,
  version,
  mapState,
  mapMutations,
  mapGetters,
  mapActions,
  createNamespacedHelpers,
  createLogger
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vuex/dist/vuex.mjs
// module id = wm1T
// module chunks = 0